export default "__VITE_ASSET__CFw$6iZw__"